import { EventEmitter } from "@angular/core";

import { GlobalCacheConfig } from "ts-cacheable";

export const cacheClear$ = new EventEmitter<void>();

GlobalCacheConfig.maxCacheCount = 100;
